import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { CommunityTemplate } from '@libs/src/models/community-template.model';
import { Label } from '@libs/src/models/label.model';
import { PlatformProgramTemplate } from '@libs/src/platform-config/platform-program-template';
import { PlatformSurveyQuestionTemplate } from '@libs/src/platform-config/platform-survey-question-template';
import { PlatformSurveyTemplate } from '@libs/src/platform-config/platform-survey-template';

const PLATFORM_CONFIG_API_URL = '/api/v3/platform-config';

@Injectable({ providedIn: 'root' })
export class PlatformConfigBackend {
  constructor(private readonly http: HttpClient) {}

  deleteProgramTemplate(templateId: string) {
    return this.http.delete<{ message: string }>(
      `${PLATFORM_CONFIG_API_URL}/program-templates/${templateId}`,
    );
  }

  deleteSurveyQuestionTemplate(templateId: string) {
    return this.http.delete<{ message: string }>(
      `${PLATFORM_CONFIG_API_URL}/survey-question-templates/${templateId}`,
    );
  }

  deleteSurveyTemplate(templateId: string) {
    return this.http.delete<{ message: string }>(
      `${PLATFORM_CONFIG_API_URL}/survey-templates/${templateId}`,
    );
  }

  getCommunityTemplates() {
    return this.http.get<{ communityTemplates: CommunityTemplate[] }>(
      `${PLATFORM_CONFIG_API_URL}/community-templates`,
    );
  }

  getProgramTemplates() {
    return this.http.get<{ programTemplates: PlatformProgramTemplate[] }>(
      `${PLATFORM_CONFIG_API_URL}/program-templates`,
    );
  }

  getSurveyQuestionTemplates() {
    return this.http.get(
      `${PLATFORM_CONFIG_API_URL}/survey-question-templates`,
    );
  }

  getSurveyTemplates() {
    return this.http.get<{ surveyTemplates: PlatformSurveyTemplate[] }>(
      `${PLATFORM_CONFIG_API_URL}/survey-templates`,
    );
  }

  patchProgramTemplate(
    templateId: string,
    update: Partial<PlatformProgramTemplate>,
  ) {
    return this.http.patch<{ programTemplate: PlatformProgramTemplate }>(
      `${PLATFORM_CONFIG_API_URL}/program-templates/${templateId}`,
      update,
    );
  }

  patchSurveyQuestionTemplate(
    templateId: string,
    update: Partial<PlatformSurveyQuestionTemplate>,
  ) {
    return this.http.patch<{
      surveyQuestionTemplate: PlatformSurveyQuestionTemplate;
    }>(
      `${PLATFORM_CONFIG_API_URL}/survey-question-templates/${templateId}`,
      update,
    );
  }

  patchSurveyTemplate(
    templateId: string,
    update: Partial<PlatformSurveyTemplate>,
  ) {
    return this.http.patch<{
      surveyTemplate: PlatformSurveyTemplate;
    }>(`${PLATFORM_CONFIG_API_URL}/survey-templates/${templateId}`, update);
  }

  postProgramTemplate(body: Partial<PlatformProgramTemplate>) {
    return this.http.post<{ programTemplate: PlatformProgramTemplate }>(
      `${PLATFORM_CONFIG_API_URL}/program-templates`,
      body,
    );
  }

  postSurveyQuestionTemplate(body: Partial<PlatformSurveyQuestionTemplate>) {
    return this.http.post<{
      surveyQuestionTemplate: PlatformSurveyQuestionTemplate;
    }>(`${PLATFORM_CONFIG_API_URL}/survey-question-templates`, body);
  }

  postSurveyTemplate(body: Partial<PlatformSurveyTemplate>) {
    return this.http.post<{
      surveyTemplate: PlatformSurveyTemplate;
    }>(`${PLATFORM_CONFIG_API_URL}/survey-templates`, body);
  }

  getLabels() {
    return this.http.get<{ labels: Label[] }>(
      `${PLATFORM_CONFIG_API_URL}/labels`,
    );
  }
}
